import { Helmet } from 'react-helmet';
import MenuWithLogo from '~/modules/Elements/MenuWithLogo';
import useSmoothNavigate from '~/modules/hooks/useSmoothNavigate';
import SelectInputView from '~/routes/SelectInput/SelectInputView';

function SelectInput() {
  const navigate = useSmoothNavigate();

  return (
    <MenuWithLogo
      showLogo={false}
      showGithubRibbon={false}
      supportedBrowsers={false}
      backgroundImage="/menu_background_blur.png"
      backgroundOverlay={true}
      toolbar={true}
      layout="plain">
      <Helmet>
        <title>Setup Microphones | fastKaraoke</title>
      </Helmet>

      <div className="mx-auto w-full max-w-[980px] px-3 sm:px-6">
        <div
          className="rounded-lg border px-4 py-5 backdrop-blur-xl sm:px-8 sm:py-8"
          style={{
            background: 'var(--walky-surface-translucent)',
            borderColor: 'var(--walky-border)',
            boxShadow: 'var(--walky-shadow-strong)',
          }}>
          <SelectInputView onFinish={() => navigate('')} closeButtonText={'Go to song list'} />
        </div>
      </div>
    </MenuWithLogo>
  );
}

export default SelectInput;
